import axios from 'axios'

export default class DiscountService {
  static async getDiscounts (organizationNumber) {
    return axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/discount/', {
        params: {
          organizationNumber: organizationNumber
        }
      })
      .then(response => response.data)
  }
}